import { Box } from "@mui/material";
import styled from "styled-components";

export const SlotCardStyled = styled(Box)`
    background: var(--light-blue-color);
    box-shadow: 0px 0px 4px 0px #F0F0F066;
    border-radius: 16px;
    display: flex;
    flex-basis: calc((100% - 40px) / 3);
    flex-direction: column;
    gap: 12px;
    cursor: pointer;
    color: var(--royal-blue-color);
    &.selected {
        box-shadow: 0 0 0 1px var(--royal-blue-color);
    }
    p {
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 10px;
    }
    .load-more {
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 10px;
    }
`